/**
 * PlantApi
 * 1.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "@oazapfts/runtime";
import * as QS from "@oazapfts/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/"
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type ExpirationTypeEnum = "none" | "day" | "week" | "month" | "year";
export type OrganizationSubscriptionDto = {
    subscriptionId: number;
    subscriptionName: string | null;
    slug: string | null;
    expirationDate?: string | null;
    expirationType: ExpirationTypeEnum;
    isTrialPeriod: boolean;
    isFree: boolean;
    isExpired: boolean;
    daysLeft: number;
    isActive: boolean;
    facilityCap: number;
    equipmentAreaCap: number;
    paymentInfoRequired: boolean;
};
export type OrganizationDto = {
    id: number;
    name?: string | null;
    industry?: string | null;
    industryId?: number | null;
    active: boolean;
    subscription?: OrganizationSubscriptionDto;
    elegibleForTrialPeriod: boolean;
    userCanManageSubscription: boolean;
    paymentInfoRequired: boolean;
    facilityCount: number;
    activeFacilityCount: number;
    maxFacilityCount: number;
    equipmentAreaCount: number;
    activeEquipmentAreaCount: number;
    maxEquipmentAreaCount: number;
};
export type DataStatus = "success" | "notValid" | "exception" | "error" | "inUse" | "notFound" | "noChange" | "inProgress" | "invalidPage" | "notAuthorized" | "duplicateEntity" | "noContent" | "accepted";
export type ErrorResponse = {
    message: string;
    kind: DataStatus;
    exception?: string | null;
    stackTrace?: string | null;
    exceptionType?: string | null;
    innerException?: string | null;
    validationErrors?: {
        [key: string]: string[];
    } | null;
};
export type EmployeeDto = {
    "number": number;
    firstName: string;
    middleInitial: string;
    lastName: string;
    address1: string;
    address2: string;
    address3: string;
    phone1: string;
    phone2: string;
    hired?: string | null;
    terminated?: string | null;
    payRate: number;
    payPeriod: string;
    comment: string;
    jobClass: string;
    supervisor: boolean;
    department: number;
    team: boolean;
    supervisorNumber: number;
    shift: number;
    emailAddress: string;
    smsAddress: string;
};
export type OrganizationFromUnifiedLoginDto = {
    industry?: string | null;
    industryId?: number | null;
    subscriptionId: number;
};
export type ValidationProblemDetails = {
    "type"?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors: {
        [key: string]: string[];
    };
    [key: string]: any;
};
export type OrganizationDetailsDto = {
    name?: string | null;
    industryId?: number | null;
};
export function getCurrentOrganization(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/organizations/current", {
        ...opts
    });
}
export function getOrganizationUsers(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: EmployeeDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/organizations/users", {
        ...opts
    });
}
export function createOrganization(organizationFromUnifiedLoginDto: OrganizationFromUnifiedLoginDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/organizations/createFromUnifiedLogin", oazapfts.json({
        ...opts,
        method: "POST",
        body: organizationFromUnifiedLoginDto
    }));
}
export function updateOrganization(organizationDto: OrganizationDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/organizations", oazapfts.json({
        ...opts,
        method: "PUT",
        body: organizationDto
    }));
}
export function updateOrganizationUpdateDetails(organizationDetailsDto: OrganizationDetailsDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/organizations/details", oazapfts.json({
        ...opts,
        method: "PATCH",
        body: organizationDetailsDto
    }));
}
export function removeUserFromOrganization(userId: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/organizations/user/${encodeURIComponent(userId)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function changeSubscription(body: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationSubscriptionDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/organizations/changesubscription", oazapfts.json({
        ...opts,
        method: "PATCH",
        body
    }));
}
export function cancelSubscription(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/setup/organizations/subscription", {
        ...opts,
        method: "DELETE"
    });
}
export function setHasPaymentInfo(hasPaymentInfo: boolean, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/setup/organizations/subscription/haspaymentinfo/${encodeURIComponent(hasPaymentInfo)}`, {
        ...opts,
        method: "PATCH"
    });
}
